import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button/Button';

import './styles.scss';

export class IconButton extends React.PureComponent {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    hiddenLabel: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const { icon, onClick, hiddenLabel } = this.props;
    // IconButton uses the hiddenLabel prop as hidden screen reader text
    return (
      <icon-button>
        <Button
          {...{ icon, onClick }}
          colour="white"
          shape="square"
          title={hiddenLabel}
        >
          <span className="hidden-text"> {hiddenLabel}</span>
        </Button>
      </icon-button>
    );
  }
}
